import * as React from 'react';
import { styled } from '@staffino/primitive-controls';

const SingleLineInput = styled.input((props) => ({
  border: 0,
  height: '3.125rem',
  paddingTop: '10px',
  zIndex: 100,
  // fontSize: '1rem',
  backgroundColor: 'transparent !important',
  color: '#1f263a !important',
  ...(props.type === 'email' ? { lineHeight: 1.5 } : {}),
  ...(props.type === 'password'
    ? {
        fontSize: '1rem',
        letterSpacing: '7px',
        color: '#586474 !important',
        /* fixing strange padding on safari */
        webkitPaddingBefore: '0px',
        '@media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm)':
          {
            paddingTop: '10px',
          },
      }
    : {}),
  ...(props.disabled ? { color: '#dadada !important' } : {}),
  '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active':
    {
      webkitBoxShadow: '0 0 0 30px white inset !important',
    },
}));

type Props = JSX.IntrinsicElements['input'];

const TextField = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLInputElement>) => (
    <SingleLineInput ref={ref} {...props} />
  ),
);

export default TextField;
